module.exports = __webpack_public_path__ + "ro.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ro.svg
// module id = 780
// module chunks = 0